import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Checkbox,
  Grid,
  Tooltip,
  Table,
  TableRow,
  TableCell,
  Button,
  Divider,
  FormControlLabel,
  FormGroup,
  Switch,
  ListItem,
  ListItemText,
  Chip,
  Box,
  TextField,
  Paper,
  TableContainer,
  TableHead,
  TableBody,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import usePageTitle from "app/pageTitle";

import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";
import DataTable from "theme/Tables/DataTable";
import axios from "axios.js";
import { useAwaitDialog } from "app/components/status_dialog";
import * as XLSX from "xlsx";
import AppConfig from "appConfig";

function CallCenterPage() {
  const pageTitle = "Voice - Call Center";
  usePageTitle(pageTitle);
  const { ref } = useParams();
  const navigate = useNavigate();

  const statusDialog = useAwaitDialog();
  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);
  function triggerRefresh() {
    setRefreshPage((prev) => !prev);
  }

  const [currency, setCurrency] = useState(null);
  const [callCenter, setCallCenter] = useState(null);
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [callCenterNumbers, setCallCenterNumbers] = useState([]);
  const [agentGroups, setAgentGroups] = useState([]);
  const [callCenterAgentGroups, setCallCenterAgentGroups] = useState([]);
  const [contacts, setContacts] = useState(0);
  const [tags, setTags] = useState([]);
  const [callOutcomes, setCallOutcomes] = useState([]);
  const [resultData, setResultData] = useState({});

  const [tableRows, setTableRows] = useState([]);
  const [selectedAgentGroup, setSelectedAgentGroup] = useState(null);
  const [selectedTags, setSelectedTags] = useState([]);
  const [openNewAgentGroupDialog, setOpenNewAgentGroupDialog] = useState(false);

  const [selectedNumber, setSelectedNumber] = useState(null);
  const [openAttachNumberDialog, setOpenAttachNumberDialog] = useState(false);

  const [entityTitle, setEntityTitle] = useState(null);
  const [openOutcomeDialog, setOpenOutcomeDialog] = useState(false);
  const [openTagDialog, setOpenTagDialog] = useState(false);

  const [uploadFile, setUploadFile] = useState(null);
  const [selectedTag, setSelectedTag] = useState(null);
  const [openUploadContactsDialog, setOpenUploadContactsDialog] = useState(false);

  const [subscription, setSubscription] = useState(null);
  const [tiers, setTiers] = useState([]);
  const [selectedTier, setSelectedTier] = useState(null);
  const [selectedTierObject, setSelectedTierObject] = useState({});
  const [subscriptionDuration, setSubscriptionDuration] = useState(1);
  const [openSubscriptionDialog, setOpenSubscriptionDialog] = useState(false);
  const [addons, setAddons] = useState([]);
  const [selectedAddon, setSelectedAddon] = useState(null);
  const [openAddonDialog, setOpenAddonDialog] = useState(false);

  const [voicemailText, setVoicemailText] = useState(null);
  const [voicemailAudio, setVoicemailAudio] = useState(null);
  const [voicemailMsg, setVoicemailMsg] = useState(null);
  const [voicemailFile, setVoicemailFile] = useState(null);
  const [openVoicemailDialog, setOpenVoicemailDialog] = useState(false);

  const [operatingHours, setOperatingHours] = useState([]);
  const [operatingDay, setOperatingDay] = useState(null);
  const [operatingDirection, setOperatingDirection] = useState(null);
  const [operatingStart, setOperatingStart] = useState(null);
  const [operatingEnd, setOperatingEnd] = useState(null);
  const [operatingEnabled, setOperatingEnabled] = useState(false);
  const [operatingGroup, setOperatingGroup] = useState(null);
  const [openOperatingHoursDialog, setOpenOperatingHoursDialog] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/voice/call_centers/${ref}/fetch.json`)
        .then((result) => {
          console.log(result.data.data);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCurrency(result.data.currency);
            setResultData(result.data.data.campaign);
            setCallCenter(result.data.data.center);
            setPhoneNumbers(result.data.data.phone_numbers);
            setCallCenterNumbers(result.data.data.call_center_numbers);
            setContacts(result.data.data.contact_count);
            setTags(result.data.data.tags);
            setCallOutcomes(result.data.data.outcomes);

            setOperatingHours(result.data.data.operating_hours);

            setVoicemailText(result.data.data.voicemail?.text);
            setVoicemailAudio(result.data.data.voicemail?.file);

            setAgentGroups(result.data.data.agent_groups);
            setCallCenterAgentGroups(result.data.data.call_center_groups);
            const rows = buildAgentGroupRows(result.data.data.call_center_groups);
            setTableRows(rows);

            setSubscription(result.data.data.subscription);
            setTiers(result.data.data.tiers);
            setAddons(result.data.data.addons);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function attachBusinessNumber() {
    if (selectedNumber === null) {
      setSeverity("error");
      setErrMsg("Select a business number");
      setOpen(true);
      return;
    }

    setOpenAttachNumberDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      number: selectedNumber,
    };

    await axios
      .post("/portal/voice/call_centers/numbers/attach.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function removeBusinessNumber(numberRef) {
    setShowLoading(true);
    await axios
      .get(`/portal/voice/call_centers/numbers/${numberRef}/remove.json`)
      .then(async (result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function updateCallDirection(direction) {
    setShowLoading(true);
    const json = {
      reference: ref,
      type: direction,
    };

    await axios
      .post("/portal/voice/call_centers/direction/update.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteAgentGroup(groupRef) {
    setShowLoading(true);
    await axios
      .get(`/portal/voice/call_centers/groups/${groupRef}/remove.json`)
      .then(async (result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteAgentGroupTag(tagRef) {
    setShowLoading(true);
    await axios
      .get(`/portal/voice/call_centers/groups/tags/${tagRef}/remove.json`)
      .then(async (result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function updateAgentGroupStatus(groupRef) {
    setShowLoading(true);
    await axios
      .get(`/portal/voice/call_centers/groups/${groupRef}/status.json`)
      .then(async (result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function assignAgentGroup() {
    if (selectedAgentGroup === null) {
      setSeverity("error");
      setErrMsg("An agent group is required.");
      setOpen(true);
      return;
    }

    setOpenNewAgentGroupDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      group: selectedAgentGroup,
      tags: selectedTags,
    };

    await axios
      .post("/portal/voice/call_centers/groups/assign.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const agentGroupTableColumns = [
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Tags", accessor: "tags", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildAgentGroupRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        name: row.title,
        tags:
          row.tags.length > 0 ? (
            <MDBox display="flex" flexWrap="wrap" gap={0.5}>
              {row.tags.map((tag) => (
                <Chip
                  size="small"
                  key={tag.reference}
                  label={tag.title}
                  onDelete={() => {
                    if (window.confirm("Delete tag?") === true) {
                      deleteAgentGroupTag(tag.reference);
                    }
                  }}
                />
              ))}
            </MDBox>
          ) : (
            "---"
          ),
        status: (
          <MDBox>
            <Icon color={row.status ? "success" : "error"}>
              {row.status ? "check_circle" : "cancel"}
            </Icon>
          </MDBox>
        ),
        actions: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="outlined"
              color="info"
              iconOnly
              onClick={() => {
                if (window.confirm(`${row.status ? "Disable" : "Enable"} this group?`) === true) {
                  updateAgentGroupStatus(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                {row.status ? "pause" : "play_arrow"}
              </Icon>
            </MDButton>
            &nbsp; &nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Remove this group?`) === true) {
                  deleteAgentGroup(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
      });
      return null;
    });

    return rows;
  };

  async function deleteOutcome(outcomeRef) {
    setShowLoading(true);
    await axios
      .get(`/portal/voice/call_centers/outcomes/${outcomeRef}/remove.json`)
      .then(async (result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteTag(tagRef) {
    setShowLoading(true);
    await axios
      .get(`/portal/voice/call_centers/tags/${tagRef}/remove.json`)
      .then(async (result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function createTag() {
    setOpenTagDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      title: entityTitle,
    };

    await axios
      .post("/portal/voice/call_centers/tags/create.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function createOutcome() {
    setOpenOutcomeDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      title: entityTitle,
    };

    await axios
      .post("/portal/voice/call_centers/outcomes/create.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function fileSelected(e) {
    const fileTypes = ["xlsx", "xls", "csv"];
    const file = e.target.files[0];
    if (!file) return;

    const extension = file.name.split(".").pop().toLowerCase();
    const supported = fileTypes.includes(extension);
    if (!supported) {
      setSeverity("error");
      setErrMsg("Only excel and csv files accepted.");
      setOpen(true);
      return;
    }

    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data, { type: "array" });
      const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });

      if (!json.length) {
        throw new Error("Empty file");
      }

      // First row = headers
      const headers = json[0].map((h) => String(h).toLowerCase().trim());
      const requiredColumns = ["name", "phone_number"];
      const missing = requiredColumns.filter((col) => !headers.includes(col));
      if (missing.length > 0) {
        setSeverity("error");
        setErrMsg(`Missing required columns: ${missing.join(", ")}`);
        setOpen(true);
        return;
      }

      setUploadFile(file);
    } catch (err) {
      setSeverity("error");
      setErrMsg("Invalid or unreadable file.");
      setOpen(true);
    }
  }

  async function uploadContacts() {
    if (!uploadFile) {
      return;
    }

    const formData = new FormData();
    formData.append("reference", ref);
    if (selectedTag) {
      formData.append("tag", selectedTag);
    }
    formData.append("file", uploadFile);

    // console.log(formData)
    setOpenUploadContactsDialog(false);
    setShowLoading(true);
    await axios
      .post("/portal/voice/call_centers/contacts/upload.json", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  async function subscribe() {
    if (selectedTier === null) {
      setSeverity("error");
      setErrMsg("A tier is required.");
      setOpen(true);
      return;
    }

    let tier = selectedTier;
    setSelectedTier(null);

    setOpenSubscriptionDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      tier: tier.reference,
      duration: subscriptionDuration,
    };

    await axios
      .post("/portal/voice/call_centers/subscription/subscribe.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function buyAddon(addon) {
    if (addon === null) {
      setSeverity("error");
      setErrMsg("An addon is required.");
      setOpen(true);
      return;
    }

    setOpenAddonDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      bundle: addon.reference,
    };

    await axios
      .post("/portal/voice/call_centers/addon/purchase.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function setVoicemailRecording(e) {
    const fileTypes = ["mp3", "wav"];
    const file = e.target.files[0];
    if (!file) return;

    const extension = file.name.split(".").pop().toLowerCase();
    const supported = fileTypes.includes(extension);
    if (!supported) {
      setSeverity("error");
      setErrMsg("Only mp3 and wav files accepted.");
      setOpen(true);
      return;
    }

    setVoicemailMsg(null);
    setVoicemailFile(file);
  }

  async function setVoicemail() {
    if (!voicemailMsg && !voicemailFile) {
      setSeverity("error");
      setErrMsg("Voicemail message or pre-recorded audio file required.");
      setOpen(true);
      return;
    }

    const formData = new FormData();
    formData.append("reference", ref);
    if (voicemailMsg) {
      formData.append("text", voicemailMsg);
    }

    if (voicemailFile) {
      formData.append("file", voicemailFile);
    }

    // console.log(formData)
    setOpenVoicemailDialog(false);
    setShowLoading(true);
    await axios
      .post("/portal/voice/call_centers/voicemail/update.json", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  async function deleteVoicemail() {
    if (window.confirm("Delete voicemail?") === false) {
      return;
    }

    setShowLoading(true);
    await axios
      .get(`/portal/voice/call_centers/voicemail/${ref}/delete.json`)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  function generateTimeArray() {
    const startTime = new Date();
    const endTime = new Date();
    startTime.setHours(0, 0, 0, 0);
    endTime.setHours(23, 59, 0, 0);

    const timeArray = [];
    const currentTime = new Date(startTime);

    while (currentTime <= endTime) {
      const hours = String(currentTime.getHours()).padStart(2, "0");
      const minutes = String(currentTime.getMinutes()).padStart(2, "0");
      timeArray.push(`${hours}:${minutes}`);
      currentTime.setMinutes(currentTime.getMinutes() + 30);
    }

    return timeArray;
  }
  const timeArray = generateTimeArray();

  async function saveOperationEntry() {
    if (operatingDay === null) {
      setSeverity("error");
      setErrMsg("A week day is required.");
      setOpen(true);
      return;
    }

    if (operatingDirection === null) {
      setSeverity("error");
      setErrMsg("Call direction is required.");
      setOpen(true);
      return;
    }

    if (operatingEnabled) {
      if (operatingStart === null) {
        setSeverity("error");
        setErrMsg("Select an opening hour.");
        setOpen(true);
        return;
      }

      if (operatingEnd === null) {
        setSeverity("error");
        setErrMsg("Select a closing hour.");
        setOpen(true);
        return;
      }
    }

    setOpenOperatingHoursDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      week_day: operatingDay,
      direction: operatingDirection,
      open: operatingStart,
      close: operatingEnd,
      enabled: operatingEnabled,
      group: operatingGroup,
    };

    await axios
      .post("/portal/voice/call_centers/operating_hours/create.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteOperatingRecord(recordRef) {
    if (window.confirm("Delete record?") === false) {
      return;
    }

    setShowLoading(true);
    await axios
      .get(`/portal/voice/call_centers/operating_hours/${recordRef}/delete.json`)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  const WEEK_DAYS = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];
  const orderedOperatingHours = WEEK_DAYS.filter((day) => operatingHours?.[day]).map((day) => [
    day,
    operatingHours[day],
  ]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openVoicemailDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Set Voicemail</MDBox>
        </DialogTitle>
        <DialogContent>
          <Alert severity="info">
            <MDTypography fontSize={12}>
              Set a message that will be said to customers or a pre-recorded audio that will be
              played to your customers.
            </MDTypography>
          </Alert>
          <MDBox mt={3}>
            <MDInput
              label="Voicemail Message"
              fullWidth
              multiline
              minRows={2}
              onChange={(e) => {
                setVoicemailFile(null);
                setVoicemailMsg(e.target.value);
              }}
            />
          </MDBox>
          <MDBox mt={3}>
            <TextField
              accept=".mp3, .wav"
              type="file"
              name="upload_file"
              id="upload_file"
              onChange={(e) => setVoicemailRecording(e)}
              fullWidth
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenVoicemailDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              setVoicemail();
            }}
          >
            Save
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openOperatingHoursDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Set Operating Hours</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={1}>
            <FormControl fullWidth>
              <InputLabel>Day Of Week</InputLabel>
              <Select
                label="Day Of Week"
                onChange={(e) => {
                  setOperatingDay(e.target.value);
                }}
                sx={{ padding: "12px", paddingLeft: "3px" }}
              >
                <MenuItem value="MONDAY">Monday</MenuItem>
                <MenuItem value="TUESDAY">Tuesday</MenuItem>
                <MenuItem value="WEDNESDAY">Wednesday</MenuItem>
                <MenuItem value="THURSDAY">Thursday</MenuItem>
                <MenuItem value="FRIDAY">Friday</MenuItem>
                <MenuItem value="SATURDAY">Saturday</MenuItem>
                <MenuItem value="SUNDAY">Sunday</MenuItem>
              </Select>
            </FormControl>
          </MDBox>

          <MDBox mt={3}>
            <FormControl fullWidth>
              <InputLabel>Call Direction</InputLabel>
              <Select
                label="Call Direction"
                onChange={(e) => {
                  setOperatingDirection(e.target.value);
                }}
                sx={{ padding: "12px", paddingLeft: "3px" }}
              >
                <MenuItem value="inbound">Inbound</MenuItem>
                <MenuItem value="outbound">Outbound</MenuItem>
              </Select>
            </FormControl>
          </MDBox>
          <MDBox mt={2} display="flex" alignItems="center" ml={-1}>
            <Checkbox
              checked={operatingEnabled}
              onChange={(e) => {
                setOperatingEnabled(e.target.checked);
              }}
              inputProps={{ "aria-label": "controlled" }}
            />
            <MDTypography
              variant="button"
              fontWeight="regular"
              color="text"
              sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
            >
              &nbsp;&nbsp;Allow Calls?
            </MDTypography>
          </MDBox>
          {operatingEnabled && (
            <MDBox mt={2}>
              <Grid container spacing={3}>
                <Grid item xs={6} md={6} lg={6}>
                  <MDBox>
                    <FormControl fullWidth>
                      <InputLabel>Opening Time</InputLabel>
                      <Select
                        label="Opening Time"
                        onChange={(e) => {
                          setOperatingStart(e.target.value);
                        }}
                        sx={{ padding: "12px", paddingLeft: "3px" }}
                      >
                        {timeArray.map((row) => (
                          <MenuItem value={row}>{row}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </MDBox>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <MDBox>
                    <FormControl fullWidth>
                      <InputLabel>Closing Time</InputLabel>
                      <Select
                        label="Closing Time"
                        onChange={(e) => {
                          setOperatingEnd(e.target.value);
                        }}
                        sx={{ padding: "12px", paddingLeft: "3px" }}
                      >
                        {timeArray.map((row) => (
                          <MenuItem value={row}>{row}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>
          )}

          {callCenterAgentGroups.length > 0 && (
            <MDBox mt={4}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Agent Group (Optional)</InputLabel>
                <Select
                  label="Contact Tag (Optional)"
                  onChange={(e) => {
                    setOperatingGroup(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    callCenterAgentGroups.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      callCenterAgentGroups.map((record) => (
                        <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
          )}
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenOperatingHoursDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              saveOperationEntry();
            }}
          >
            Save
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openAttachNumberDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Attach Business Number</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox mt={2}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Business Number</InputLabel>
                <Select
                  label="Business Number"
                  onChange={(e) => {
                    setSelectedNumber(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    phoneNumbers.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      phoneNumbers.map((record) => (
                        <MenuItem value={`${record.reference}`}>{record.phone_number}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAttachNumberDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              attachBusinessNumber();
            }}
          >
            Attach
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openNewAgentGroupDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Assign Agent Group</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mb={5}>
            <MDBox mt={2}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Agent Group</InputLabel>
                <Select
                  label="Agent Group"
                  onChange={(e) => {
                    setSelectedAgentGroup(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    agentGroups.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      agentGroups.map((record) => (
                        <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
            {tags.length > 0 && (
              <MDBox mt={4}>
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>Contact Tags (Optional)</InputLabel>
                  <Select
                    label="Contact Tags (Optional)"
                    multiple
                    value={selectedTags}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSelectedTags(typeof value === "string" ? value.split(",") : value);
                    }}
                    renderValue={(selectedValues) => (
                      <Box display="flex" flexWrap="wrap" gap={0.5}>
                        {selectedValues.map((val) => {
                          const item = tags.find((o) => o.reference === val);
                          return <Chip key={val} label={item?.title || val} />;
                        })}
                      </Box>
                    )}
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                  >
                    {
                      // --> Notice below changes
                      tags.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                        tags.map((record) => (
                          <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                        ))
                    }
                  </Select>
                </FormControl>
              </MDBox>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenNewAgentGroupDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              assignAgentGroup();
            }}
          >
            Assign
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openOutcomeDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Create Call Outcome</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox mt={2}>
              <MDInput
                fullWidth
                label="Outcome Name"
                onChange={(e) => setEntityTitle(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenOutcomeDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              createOutcome();
            }}
          >
            Create
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openTagDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Create Contact Tag</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox mt={2}>
              <MDInput
                fullWidth
                label="Contact Tag"
                onChange={(e) => setEntityTitle(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenTagDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              createTag();
            }}
          >
            Create
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openUploadContactsDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Upload Contacts</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={1} mb={3}>
            <MDBox>
              <TextField
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                type="file"
                name="upload_file"
                id="upload_file"
                onChange={(e) => fileSelected(e)}
                fullWidth
              />
            </MDBox>
            <MDBox mt={1}>
              <Alert severity="warning">
                <MDTypography variant="subtitle2" fontSize={14}>
                  Your file must contain <b>name</b> and <b>phone_number</b> columns.
                </MDTypography>
              </Alert>
            </MDBox>
            {tags.length > 0 && (
              <MDBox mt={4}>
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>Contact Tag (Optional)</InputLabel>
                  <Select
                    label="Contact Tag (Optional)"
                    onChange={(e) => {
                      setSelectedTag(e.target.value);
                    }}
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                  >
                    {
                      // --> Notice below changes
                      tags.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                        tags.map((record) => (
                          <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                        ))
                    }
                  </Select>
                </FormControl>
              </MDBox>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenUploadContactsDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              uploadContacts();
            }}
          >
            Upload
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openSubscriptionDialog} fullWidth maxWidth="lg">
        <DialogTitle>
          <MDBox align="center" mb={1}>
            <MDTypography variant="h6" fontSize={24}>
              Activate Call Center
            </MDTypography>
            <MDTypography variant="h6" fontSize={14} fontWeight="light">
              Choose a call center plan
            </MDTypography>
          </MDBox>
          <MDBox>
            <Divider />
          </MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mb={3}>
            <MDBox>
              <Grid container spacing={3}>
                {tiers.map((tier) => (
                  <Grid item xs={12} md={4} lg={4}>
                    <Paper>
                      <MDBox py={2} align="center">
                        <MDBox>
                          <MDTypography variant="h6">{tier.title}</MDTypography>
                          <MDTypography fontSize={15}>{`${currency}${(
                            tier.price / 100
                          ).toLocaleString("en", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}`}</MDTypography>
                          <MDTypography fontSize={9}>{`${currency}${(tier.vat / 100).toLocaleString(
                            "en",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )} VAT`}</MDTypography>
                        </MDBox>
                        <MDBox>
                          <Divider />
                        </MDBox>
                        <MDBox mt={3}>
                          <Table>
                            <TableRow>
                              <TableCell>
                                <MDTypography>
                                  <MDTypography fontSize={12}>Business Numbers</MDTypography>
                                </MDTypography>
                              </TableCell>
                              <TableCell>
                                <MDTypography align="right" fontSize={12}>
                                  {tier.numbers}
                                </MDTypography>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                                <MDTypography>
                                  <MDTypography fontSize={12}>Concurrency</MDTypography>
                                </MDTypography>
                              </TableCell>
                              <TableCell>
                                <MDTypography align="right" fontSize={12}>
                                  {tier.calls} calls
                                </MDTypography>
                              </TableCell>
                            </TableRow>
                            {tier.bundles.map((addon) => (
                              <TableRow>
                                <TableCell>
                                  <MDTypography>
                                    <MDTypography fontSize={12}>{addon.addon}</MDTypography>
                                  </MDTypography>
                                </TableCell>
                                <TableCell>
                                  <MDTypography align="right" fontSize={12}>
                                    {addon.title}
                                  </MDTypography>
                                </TableCell>
                              </TableRow>
                            ))}
                          </Table>
                          <MDBox mt={1}>
                            <MDTypography variant="caption">30-day billing cycle</MDTypography>
                          </MDBox>
                        </MDBox>
                        <MDBox mt={3}>
                          <MDButton
                            color="dark"
                            variant="contained"
                            onClick={() => {
                              setSubscriptionDuration(1);
                              setSelectedTier(tier);
                            }}
                          >
                            Select
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenSubscriptionDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openAddonDialog} fullWidth maxWidth="md">
        <DialogTitle>
          <MDBox align="center" mb={1}>
            <MDTypography variant="h6">Add Ons</MDTypography>
            <MDTypography variant="h6" fontSize={14} fontWeight="light">
              Purchase add-on packs for your use case.
            </MDTypography>
          </MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mb={3}>
            <MDBox>
              <Grid container spacing={3}>
                {addons.map((add) => (
                  <Grid item xs={12} md={3} lg={3}>
                    <Paper>
                      <MDBox py={2} align="center">
                        <MDBox>
                          <MDTypography variant="caption">{add.addon}</MDTypography>
                          <MDTypography variant="h6">{add.title}</MDTypography>
                          <MDTypography fontSize={15}>{`${currency}${(
                            add.price / 100
                          ).toLocaleString("en", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}`}</MDTypography>
                        </MDBox>
                        <MDBox mt={3}>
                          <MDButton
                            color="dark"
                            variant="contained"
                            onClick={() => {
                              buyAddon(add);
                            }}
                            size="small"
                          >
                            Buy
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAddonDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
        </DialogActions>
      </Dialog>
      {selectedTier && (
        <Dialog open fullWidth maxWidth="xs">
          <DialogTitle>
            <MDTypography align="center" variant="body2" fontSize={14}>
              Capacity Tier
            </MDTypography>
            <MDTypography align="center" variant="h6">
              {selectedTier.title}
            </MDTypography>
          </DialogTitle>
          <DialogContent>
            <MDBox>
              <MDBox mt={1}>
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>Duration</InputLabel>
                  <Select
                    label="Duration"
                    onChange={(e) => {
                      setSubscriptionDuration(e.target.value);
                    }}
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                    value={subscriptionDuration}
                  >
                    <MenuItem value={1}>30 days</MenuItem>
                    <MenuItem value={3}>90 days</MenuItem>
                    <MenuItem value={6}>180 days</MenuItem>
                    <MenuItem value={12}>365 days</MenuItem>
                  </Select>
                </FormControl>
              </MDBox>
              <MDBox mt={3}>
                <Table>
                  <TableRow>
                    <TableCell>
                      <MDTypography>
                        <MDTypography fontSize={12}>Price</MDTypography>
                      </MDTypography>
                    </TableCell>
                    <TableCell>
                      <MDTypography align="right" fontSize={12}>
                        {currency}
                        {((selectedTier.price / 100) * subscriptionDuration).toLocaleString("en", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </MDTypography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <MDTypography>
                        <MDTypography fontSize={12}>VAT</MDTypography>
                      </MDTypography>
                    </TableCell>
                    <TableCell>
                      <MDTypography align="right" fontSize={12}>
                        {currency}
                        {((selectedTier.vat / 100) * subscriptionDuration).toLocaleString("en", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </MDTypography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <MDTypography>
                        <MDTypography fontSize={14} fontWeight="bold">
                          Total
                        </MDTypography>
                      </MDTypography>
                    </TableCell>
                    <TableCell>
                      <MDTypography align="right" fontWeight="bold" fontSize={14}>
                        {currency}
                        {(
                          ((selectedTier.price + selectedTier.vat) / 100) *
                          subscriptionDuration
                        ).toLocaleString("en", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </MDTypography>
                    </TableCell>
                  </TableRow>
                </Table>
              </MDBox>
            </MDBox>
          </DialogContent>
          <DialogActions>
            <MDButton
              onClick={() => {
                setSelectedTier(null);
              }}
              color="dark"
              variant="outlined"
              startIcon={<Icon>west</Icon>}
            >
              Back
            </MDButton>
            <MDButton
              onClick={() => {
                subscribe();
              }}
              color="dark"
              variant="contained"
            >
              Activate
            </MDButton>
          </DialogActions>
        </Dialog>
      )}
      <MDBox mt={0.5} mb={5}>
        {pageLoaded && (
          <MDBox>
            <MDBox mt={0} mb={2} display="flex" justifyContent="space-between">
              <MDBox>
                <Button
                  color="dark"
                  size="small"
                  startIcon={<Icon>west</Icon>}
                  onClick={() => {
                    navigate(`/voice/call-centers`);
                  }}
                >
                  Back
                </Button>
              </MDBox>
              <MDBox>
                <Button
                  size="small"
                  color="info"
                  iconOnly
                  onClick={() => {
                    navigate(`/voice/call-centers/calls/${ref}`);
                  }}
                  startIcon={
                    <Icon sx={{ cursor: "pointer" }} fontSize="small">
                      list_alt
                    </Icon>
                  }
                >
                  Call Logs
                </Button>
                &nbsp;
                <Button
                  size="small"
                  color="info"
                  iconOnly
                  onClick={() => {
                    navigate(`/voice/call-centers/insights/${ref}`);
                  }}
                  startIcon={
                    <Icon sx={{ cursor: "pointer" }} fontSize="small">
                      leaderboard
                    </Icon>
                  }
                >
                  Insights
                </Button>
              </MDBox>
            </MDBox>

            <MDBox mt={2}>
              <MDBox>
                {subscription ? (
                  <MDBox>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={4} lg={4}>
                        <Card sx={{ height: "100%" }}>
                          <MDBox align="center" p={2} sx={{ height: "100%" }}>
                            <MDTypography fontSize={42}>
                              <Icon color="success">check_circle</Icon>
                            </MDTypography>
                            <MDBox>
                              <ListItemText
                                primary={<MDTypography variant="caption">Tier</MDTypography>}
                                secondary={
                                  <MDTypography variant="h6">{subscription.tier}</MDTypography>
                                }
                              />
                            </MDBox>
                            <MDBox mt={1}>
                              <MDTypography variant="caption">Expires On</MDTypography>
                              <MDTypography fontSize={14}>{subscription.end}</MDTypography>
                            </MDBox>
                          </MDBox>
                        </Card>
                      </Grid>
                      <Grid item xs={12} md={8} lg={8}>
                        <Card sx={{ height: "100%" }}>
                          <MDBox p={2} sx={{ height: "100%" }}>
                            <MDBox mb={3} display="flex" justifyContent="space-between">
                              <MDBox mt={1}>
                                <MDTypography variant="h6" fontWeight={600} mb={1}>
                                  Add Ons
                                </MDTypography>
                              </MDBox>
                              <MDBox>
                                <MDButton
                                  color="dark"
                                  variant="contained"
                                  size="small"
                                  iconOnly
                                  onClick={() => setOpenAddonDialog(true)}
                                >
                                  <Icon>add</Icon>
                                </MDButton>
                              </MDBox>
                            </MDBox>
                            {subscription.addons.map((addon) => {
                              let progress = ((addon.balance / addon.total) * 100).toFixed(0);

                              function getColor() {
                                let color = "success.main";
                                if (progress < 60) {
                                  color = "warning.main";
                                }

                                if (progress <= 30) {
                                  color = "error.main";
                                }

                                return color;
                              }
                              return (
                                <Box mb={3}>
                                  <MDBox display="flex" justifyContent="space-between">
                                    <MDTypography
                                      variant="h6"
                                      align="right"
                                      fontWeight="regular"
                                      mb={1}
                                    >
                                      {addon.title}
                                    </MDTypography>
                                    <MDTypography
                                      variant="body2"
                                      align="right"
                                      fontWeight={600}
                                      mb={1}
                                    >
                                      {`${100 - progress}%`} used
                                    </MDTypography>
                                  </MDBox>

                                  <Box
                                    sx={{
                                      height: 6,
                                      borderRadius: 4,
                                      backgroundColor: "#e0e0e0",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        width: `${100 - progress}%`,
                                        height: "100%",
                                        backgroundColor: getColor,
                                        transition: "width 0.4s ease",
                                      }}
                                    />
                                  </Box>
                                </Box>
                              );
                            })}
                          </MDBox>
                        </Card>
                      </Grid>
                    </Grid>
                  </MDBox>
                ) : (
                  <Card>
                    <MDBox p={2}>
                      <MDBox align="center">
                        <MDTypography variant="h6" fontSize={48}>
                          <Icon color="error">warning</Icon>
                        </MDTypography>
                        <MDTypography variant="h6" fontSize={14} fontWeight="light">
                          Activation is required!
                        </MDTypography>
                        <MDBox>
                          <Divider />
                        </MDBox>
                        <MDBox mt={2} align="center">
                          <MDButton
                            variant="contained"
                            color="dark"
                            startIcon={<Icon>money</Icon>}
                            onClick={() => {
                              setSelectedTier(null);
                              setSubscriptionDuration(1);
                              setOpenSubscriptionDialog(true);
                            }}
                          >
                            Activate
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                )}
              </MDBox>
            </MDBox>

            <MDBox mt={5}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={4} lg={4}>
                  <MDBox sx={{ height: "100%", marginTop: "0px" }}>
                    <Card sx={{ height: "100%", marginTop: "0px" }}>
                      <MDBox p={2}>
                        <MDBox>
                          <MDBox>
                            <MDTypography variant="h6" fontWeight="light" fontSize={13}>
                              Call Center
                            </MDTypography>
                            <MDTypography variant="h6" fontWeight="bold" fontSize={16}>
                              {callCenter.title}
                            </MDTypography>
                          </MDBox>
                          <MDBox>
                            <Divider />
                          </MDBox>
                          <MDBox mt={3} mb={3}>
                            <MDBox>
                              <FormControlLabel
                                fullWidth
                                control={
                                  <Switch
                                    checked={callCenter.can_receive}
                                    onChange={() => updateCallDirection("incoming")}
                                  />
                                }
                                label="Incoming Calls"
                              />
                            </MDBox>
                            <MDBox mt={2}>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={callCenter.can_call}
                                    onChange={() => updateCallDirection("outgoing")}
                                  />
                                }
                                label="Outgoing Calls"
                              />
                            </MDBox>
                            {callCenter.can_call && (
                              <MDBox mt={2}>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={callCenter.allow_dial_pad}
                                      onChange={() => updateCallDirection("dial_pad")}
                                    />
                                  }
                                  label="Allow Open Dialing (Dial Pad)"
                                />
                              </MDBox>
                            )}
                          </MDBox>
                          <MDBox>
                            <Divider />
                          </MDBox>
                          <MDBox>
                            <MDBox mt={2} mb={2} display="flex" justifyContent="space-between">
                              <MDBox>
                                <MDTypography variant="h6" fontWeight="regular" fontSize={13}>
                                  Call Outcomes
                                </MDTypography>
                              </MDBox>
                              <MDBox mt={-1}>
                                <MDButton
                                  size="small"
                                  variant="contained"
                                  color="dark"
                                  iconOnly
                                  onClick={() => {
                                    setEntityTitle(null);
                                    setOpenOutcomeDialog(true);
                                  }}
                                >
                                  <Icon>add</Icon>
                                </MDButton>
                              </MDBox>
                            </MDBox>
                            <MDBox>
                              {callOutcomes.length > 0 ? (
                                <MDBox display="flex" flexWrap="wrap" gap={0.5}>
                                  {callOutcomes.map((outcome) => (
                                    <Chip
                                      key={outcome.reference}
                                      label={outcome.title}
                                      onDelete={() => {
                                        if (window.confirm("Delete record?") === true) {
                                          deleteOutcome(outcome.reference);
                                        }
                                      }}
                                    />
                                  ))}
                                </MDBox>
                              ) : (
                                <MDBox>
                                  <MDTypography variant="body2" fontSize={13}>
                                    No call outcomes have been added.
                                  </MDTypography>
                                </MDBox>
                              )}
                            </MDBox>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={4} lg={4}>
                  <MDBox sx={{ height: "100%", marginTop: "0px" }}>
                    <Card sx={{ height: "100%", marginTop: "0px" }}>
                      <MDBox p={2}>
                        <MDBox>
                          <MDBox mt={1} mb={2} display="flex" justifyContent="space-between">
                            <MDBox>
                              <MDTypography variant="h6" fontWeight="regular" fontSize={13}>
                                Business Numbers
                              </MDTypography>
                            </MDBox>
                            <MDBox mt={-1}>
                              <MDButton
                                size="small"
                                variant="contained"
                                color="dark"
                                iconOnly
                                onClick={() => {
                                  setSelectedNumber(null);
                                  setOpenAttachNumberDialog(true);
                                }}
                              >
                                <Icon>add</Icon>
                              </MDButton>
                            </MDBox>
                          </MDBox>
                          <MDBox>
                            <Divider />
                          </MDBox>
                          <MDBox mt={3} mb={3}>
                            {callCenterNumbers.length > 0 ? (
                              <MDBox>
                                {callCenterNumbers.map((n) => (
                                  <ListItem divider>
                                    <ListItemText
                                      primary={
                                        <MDTypography mb={2} variant="caption" fontSize={13}>
                                          {n.phone_number}
                                        </MDTypography>
                                      }
                                    />
                                    <MDBox mb={1}>
                                      <MDButton
                                        size="small"
                                        variant="outlined"
                                        color="error"
                                        iconOnly
                                        onClick={() => {
                                          removeBusinessNumber(n.reference);
                                        }}
                                      >
                                        <Icon>delete</Icon>
                                      </MDButton>
                                    </MDBox>
                                  </ListItem>
                                ))}
                              </MDBox>
                            ) : (
                              <MDTypography
                                align="center"
                                variant="h6"
                                fontWeight="light"
                                fontSize={13}
                              >
                                No business numbers added.
                              </MDTypography>
                            )}
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={4} lg={4}>
                  <MDBox sx={{ height: "100%", marginTop: "0px" }}>
                    <Card sx={{ height: "100%", marginTop: "0px" }}>
                      <MDBox p={2}>
                        <MDBox>
                          <MDBox mt={1} mb={2} display="flex" justifyContent="space-between">
                            <MDBox>
                              <MDTypography variant="h6" fontWeight="regular" fontSize={13}>
                                Contacts
                              </MDTypography>
                            </MDBox>
                            <MDBox mt={-1}>
                              <MDButton
                                size="small"
                                variant="contained"
                                color="dark"
                                iconOnly
                                onClick={() => {
                                  setSelectedTag(null);
                                  setUploadFile(null);
                                  setOpenUploadContactsDialog(true);
                                }}
                              >
                                <Icon>upload</Icon>
                              </MDButton>
                            </MDBox>
                          </MDBox>
                          <MDBox>
                            <Divider />
                          </MDBox>
                          <MDBox mt={3} mb={3}>
                            <MDBox align="center">
                              <MDTypography variant="h6" fontSize={36}>
                                {contacts.toLocaleString("en-US", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })}
                              </MDTypography>
                              <MDTypography mt={2} variant="h6" fontWeight="light" fontSize={13}>
                                Contacts
                              </MDTypography>
                            </MDBox>
                          </MDBox>
                          <MDBox>
                            <Divider />
                          </MDBox>
                          <MDBox>
                            <MDBox mt={2} mb={2} display="flex" justifyContent="space-between">
                              <MDBox>
                                <MDTypography variant="h6" fontWeight="regular" fontSize={13}>
                                  Contact Tags
                                </MDTypography>
                              </MDBox>
                              <MDBox mt={-1}>
                                <MDButton
                                  size="small"
                                  variant="contained"
                                  color="dark"
                                  iconOnly
                                  onClick={() => {
                                    setEntityTitle(null);
                                    setOpenTagDialog(true);
                                  }}
                                >
                                  <Icon>add</Icon>
                                </MDButton>
                              </MDBox>
                            </MDBox>
                            <MDBox>
                              {tags.length > 0 ? (
                                <MDBox display="flex" flexWrap="wrap" gap={0.5}>
                                  {tags.map((tag) => (
                                    <Chip
                                      key={tag.reference}
                                      label={tag.title}
                                      onDelete={() => {
                                        if (window.confirm("Delete record?") === true) {
                                          deleteTag(tag.reference);
                                        }
                                      }}
                                    />
                                  ))}
                                </MDBox>
                              ) : (
                                <MDBox>
                                  <MDTypography variant="body2" fontSize={13}>
                                    No contact tags have been added.
                                  </MDTypography>
                                </MDBox>
                              )}
                            </MDBox>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>

            <MDBox mt={5}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox>
                  <MDBox p={2}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center">
                      <MDTypography variant="h6" fontWeight="light">
                        <b>Agent Groups</b>
                        <br />
                        <small>
                          Assign agent groups to your call center. Set contact tags to organise your
                          teams around your contact list.
                        </small>
                      </MDTypography>
                      <MDButton
                        variant="contained"
                        color="dark"
                        iconOnly
                        onClick={() => {
                          setSelectedAgentGroup(null);
                          setSelectedTags([]);
                          setOpenNewAgentGroupDialog(true);
                        }}
                      >
                        <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                      </MDButton>
                    </MDBox>
                  </MDBox>
                  <MDBox>
                    <DataTable
                      table={{ columns: agentGroupTableColumns, rows: tableRows }}
                      isSorted
                      entriesPerPage={false}
                      showTotalEntries
                      buttons
                      noEndBorder
                    />
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>

            <MDBox mt={5}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox p={2}>
                  <MDBox>
                    <MDTypography variant="h6">Voicemail</MDTypography>
                    <Divider />
                  </MDBox>
                  <MDBox mt={2}>
                    {voicemailText || voicemailAudio ? (
                      <MDBox>
                        {voicemailText && (
                          <MDInput
                            fullWidth
                            InputProps={{
                              readOnly: true,
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Icon fontSize="small">voicemail</Icon>
                                </InputAdornment>
                              ),
                            }}
                            value={voicemailText}
                          />
                        )}
                        {voicemailAudio && (
                          <audio src={`${AppConfig.api_media_url}${voicemailAudio}`} controls>
                            Your browser does not support the audio element.
                          </audio>
                        )}
                      </MDBox>
                    ) : (
                      <MDBox>
                        <MDTypography variant="body2" fontSize={14}>
                          Set a voice mail to play to your customers when your call center is closed
                          or unavailable.
                        </MDTypography>
                      </MDBox>
                    )}
                    <MDBox mt={3} display="flex" justifyContent="start">
                      {(voicemailText || voicemailAudio) && (
                        <MDBox mr={2}>
                          <MDButton
                            variant="contained"
                            color="error"
                            size="small"
                            startIcon={<Icon>delete</Icon>}
                            onClick={() => deleteVoicemail()}
                          >
                            Delete Voicemail
                          </MDButton>
                        </MDBox>
                      )}
                      <MDBox>
                        <MDButton
                          variant="contained"
                          color="dark"
                          size="small"
                          startIcon={<Icon>voicemail</Icon>}
                          onClick={() => {
                            setVoicemailFile(null);
                            setVoicemailMsg(null);

                            setOpenVoicemailDialog(true);
                          }}
                        >
                          {voicemailText || voicemailAudio ? "Update Voicemail" : "Set Voicemail"}
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>

            <MDBox mt={5}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox p={2}>
                  <MDBox mb={2} display="flex" justifyContent="space-between">
                    <MDBox>
                      <MDTypography variant="h6">Operating Hours</MDTypography>
                    </MDBox>
                    <MDBox mt={-1}>
                      <MDButton
                        size="small"
                        variant="contained"
                        color="dark"
                        iconOnly
                        onClick={() => {
                          setOperatingDay(null);
                          setOperatingDirection(null);
                          setOperatingStart(null);
                          setOperatingEnd(null);
                          setOperatingEnabled(false);
                          setOperatingGroup(null);
                          setOpenOperatingHoursDialog(true);
                        }}
                      >
                        <Icon>add</Icon>
                      </MDButton>
                    </MDBox>
                  </MDBox>
                  <MDBox>
                    <Divider />
                  </MDBox>
                  <MDBox mt={2}>
                    {orderedOperatingHours.length > 0 ? (
                      <MDBox>
                        <Grid container rowSpacing={2} columnSpacing={0}>
                          {orderedOperatingHours.map(([day, schedules]) => (
                            <Grid item xs={6} md={3} lg={3} key={day}>
                              <Card
                                sx={{
                                  height: "100%",
                                  marginTop: "0px",
                                  borderRadius: 0,
                                  border: "0.5px solid #e0e0e0",
                                }}
                              >
                                <MDBox p={2}>
                                  <MDTypography align="center" variant="h6">
                                    {day}
                                  </MDTypography>
                                  <MDBox mt={0}>
                                    {schedules.map((row) => (
                                      <Card
                                        key={row.reference}
                                        sx={{
                                          mt: 2.5,
                                          border: "1px solid #e0e0e0",
                                          boxShadow: "none",
                                        }}
                                      >
                                        <MDBox p={1.5}>
                                          <MDBox
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="center"
                                          >
                                            <MDBox>
                                              <MDBox display="flex" alignItems="center">
                                                <Icon
                                                  sx={{
                                                    fontSize: 18,
                                                    mr: 0.75,
                                                    color:
                                                      row.direction === "INBOUND"
                                                        ? "#4caf50"
                                                        : "#2196f3",
                                                  }}
                                                >
                                                  {row.direction === "INBOUND"
                                                    ? "south_west"
                                                    : "north_east"}
                                                </Icon>

                                                <MDTypography variant="caption" fontWeight="medium">
                                                  {row.direction}
                                                </MDTypography>
                                              </MDBox>
                                            </MDBox>
                                            <IconButton
                                              size="small"
                                              onClick={() => deleteOperatingRecord(row.reference)}
                                            >
                                              <Icon color="error">delete</Icon>
                                            </IconButton>
                                          </MDBox>

                                          <MDBox mt={0}>
                                            <MDTypography variant="button" fontWeight="regular">
                                              {row.agent_group || "All Agent Groups"}
                                            </MDTypography>
                                          </MDBox>

                                          <MDBox mt={-1}>
                                            <MDTypography variant="caption" color="text">
                                              {row.enabled
                                                ? `${row.open} - ${row.close}`
                                                : "Disabled"}
                                            </MDTypography>
                                          </MDBox>

                                          <MDBox mt={1.5} display="flex" alignItems="center">
                                            <Chip
                                              size="small"
                                              label={row.enabled ? "Enabled" : "Disabled"}
                                              color={row.enabled ? "success" : "error"}
                                            />
                                            {/* <FormControlLabel
                                                    control={
                                                      <Checkbox checked={row.enabled} disabled />
                                                    }
                                                    label="Enabled"
                                                  /> */}
                                          </MDBox>
                                        </MDBox>
                                      </Card>
                                    ))}
                                  </MDBox>
                                </MDBox>
                              </Card>
                            </Grid>
                          ))}
                        </Grid>
                      </MDBox>
                    ) : (
                      <MDBox>
                        <MDTypography variant="body2" fontSize={14}>
                          Set operating days and hours your business or call center will be
                          available to make and receive calls. Create team shifts for inbound and
                          outbound calls.
                        </MDTypography>
                      </MDBox>
                    )}
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CallCenterPage;
